/* unplugin-vue-components disabled */import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/Pagination/index.vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, isRef as _isRef, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", {
  class: "form-header h4"
}, "基本信息", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", {
  class: "form-header h4"
}, "角色信息", -1);
const _hoisted_4 = {
  style: {
    "text-align": "center",
    "margin-left": "-120px",
    "margin-top": "30px"
  }
};
import { getAuthRole, updateAuthRole } from "@/api/system/user";
export default {
  __name: 'authRole',
  setup(__props) {
    const route = useRoute();
    const {
      proxy
    } = getCurrentInstance();
    const loading = ref(true);
    const total = ref(0);
    const pageNum = ref(1);
    const pageSize = ref(10);
    const roleIds = ref([]);
    const roles = ref([]);
    const form = ref({
      nickName: undefined,
      userName: undefined,
      userId: undefined
    });

    /** 单击选中行数据 */
    function clickRow(row) {
      proxy.$refs["roleRef"].toggleRowSelection(row);
    }
    ;
    /** 多选框选中数据 */
    function handleSelectionChange(selection) {
      roleIds.value = selection.map(item => item.roleId);
    }
    ;
    /** 保存选中的数据编号 */
    function getRowKey(row) {
      return row.roleId;
    }
    ;
    /** 关闭按钮 */
    function close() {
      const obj = {
        path: "/system/user"
      };
      proxy.$tab.closeOpenPage(obj);
    }
    ;
    /** 提交按钮 */
    function submitForm() {
      const userId = form.value.userId;
      const rIds = roleIds.value.join(",");
      updateAuthRole({
        userId: userId,
        roleIds: rIds
      }).then(response => {
        proxy.$modal.msgSuccess("授权成功");
        close();
      });
    }
    ;
    (() => {
      const userId = route.params && route.params.userId;
      if (userId) {
        loading.value = true;
        getAuthRole(userId).then(response => {
          form.value = response.user;
          roles.value = response.roles;
          total.value = roles.value.length;
          nextTick(() => {
            roles.value.forEach(row => {
              if (row.flag) {
                proxy.$refs["roleRef"].toggleRowSelection(row);
              }
            });
          });
          loading.value = false;
        });
      }
    })();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_0;
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
        model: _unref(form),
        "label-width": "80px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8,
            offset: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "用户昵称",
              prop: "nickName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(form).nickName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).nickName = $event),
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            offset: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "登录账号",
              prop: "userName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(form).userName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).userName = $event),
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _hoisted_3, _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "row-key": getRowKey,
        onRowClick: clickRow,
        ref: "roleRef",
        onSelectionChange: handleSelectionChange,
        data: _unref(roles).slice((_unref(pageNum) - 1) * _unref(pageSize), _unref(pageNum) * _unref(pageSize))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          width: "55",
          type: "index",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString((_unref(pageNum) - 1) * _unref(pageSize) + scope.$index + 1), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          type: "selection",
          "reserve-selection": true,
          width: "55"
        }), _createVNode(_component_el_table_column, {
          label: "角色编号",
          align: "center",
          prop: "roleId"
        }), _createVNode(_component_el_table_column, {
          label: "角色名称",
          align: "center",
          prop: "roleName"
        }), _createVNode(_component_el_table_column, {
          label: "权限字符",
          align: "center",
          prop: "roleKey"
        }), _createVNode(_component_el_table_column, {
          label: "创建时间",
          align: "center",
          prop: "createTime",
          width: "180"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.createTime)), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, _unref(loading)]]), _withDirectives(_createVNode(_component_pagination, {
        total: _unref(total),
        page: _unref(pageNum),
        "onUpdate:page": _cache[2] || (_cache[2] = $event => _isRef(pageNum) ? pageNum.value = $event : null),
        limit: _unref(pageSize),
        "onUpdate:limit": _cache[3] || (_cache[3] = $event => _isRef(pageSize) ? pageSize.value = $event : null)
      }, null, 8, ["total", "page", "limit"]), [[_vShow, _unref(total) > 0]]), _createVNode(_component_el_form, {
        "label-width": "100px"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => submitForm())
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => close())
        }, {
          default: _withCtx(() => [_createTextVNode("返回")]),
          _: 1
        })])]),
        _: 1
      })]);
    };
  }
};